module.exports = __webpack_public_path__ + "img/6C8996_14223F_B9DEDD_2E445C-256px.315846b1.png";